import React from "react";
import { useSelector } from "react-redux";
import StackedPieChart from "./../../../../components/stackedPieChart/stackedPieChart";

export const SalesActivityPieChart = () => {
  const {
    chartInfo: { data },
    summaryInfo: { revenue, revenueRawDataLink, change }
  } = useSelector((state) => state.studioInfo.salesActivityRevenue);

  return (
    <StackedPieChart
      data={data}
      width={650}
      isCurrency
      legendsTooltipId="sales-activity-legends-tooltip"
      hideLegendMetrics
      chartStats={[
        {
          title: "Net Revenue",
          value: revenue,
          valueRawDataLink: revenueRawDataLink,
          percentChange: change
        }
      ]}
    />
  );
};
